var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1108,
    height: 900,
    viewBox: "0 0 1108 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M736 541C873.969 841.5 745.211 1150.4 466.099 1278.55L-213 993.5C-193.22 823.603 -235.8 995.377 -311.5 830.5L-104.5 -99.0125C249.5 -83.5 206.5 -46.5 362 -46.5L642.405 -28.6172C608 195 621.218 291 736 541Z",
    fill: "url(#paint0_linear_351_6836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M616.192 396.27C775.838 672.786 683.293 1015 411.58 1171.87L-561.111 1733.46C-557.165 1558.73 -605.892 1383.93 -698.59 1223.37L-1289.22 246.631C-1429.56 3.56495 -524.732 147.804 -37.4995 -133.5L466.48 -174.763C455.943 24.5851 509.332 211.183 616.192 396.27Z",
    fill: "url(#paint1_linear_351_6836)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_bf_351_6836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.863 226.514C701.433 532.093 533.478 844.286 233.205 935.248L-705.583 1219.64C-765.293 1237.72 -823.226 1182.99 -817.476 1120.86C-805.696 993.594 -820.406 862.218 -859.581 732.895L-1212.57 -352.586C-1293.95 -621.201 -136.288 -142.694 402.156 -305.805L451.867 -320.864C512.617 -339.267 571.05 -282.357 563.281 -219.358C545.397 -74.3391 562.384 73.0795 608.863 226.514Z",
    fill: "url(#paint2_linear_351_6836)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_351_6836",
    x: -1236.65,
    y: -456.263,
    width: 1890.95,
    height: 1699.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_351_6836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_351_6836",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_351_6836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_351_6836",
    x1: 291.3,
    y1: 1210.12,
    x2: 316.412,
    y2: -365.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#167C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726506,
    stopColor: "#B0C355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_351_6836",
    x1: 235.304,
    y1: 1212.35,
    x2: 98.9418,
    y2: -485.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714614,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_351_6836",
    x1: 30.4449,
    y1: 862.286,
    x2: 373.432,
    y2: -944.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714614,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.73c3bf62e31d9a729152d4c04c811fb9.svg";
export { ForwardRef as ReactComponent };